module.exports = __webpack_public_path__ + "static/media/confirmation.efde331f.svg";